import { render, staticRenderFns } from "./ggsydetail.vue?vue&type=template&id=a7f23226&scoped=true&"
import script from "./ggsydetail.vue?vue&type=script&lang=js&"
export * from "./ggsydetail.vue?vue&type=script&lang=js&"
import style0 from "./ggsydetail.vue?vue&type=style&index=0&id=a7f23226&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f23226",
  null
  
)

export default component.exports